import type { GestureResponderEvent } from 'react-native'
import { Button, type IButtonProps } from '~/components/button'

import { useInputPasswordProps } from '../../hooks'
import type { TInputPasswordSizes } from '../../types'
import * as Comp from './input-password-button.styles'

export function InputPasswordButton({
  onPress,
  testID,
  ...props
}: Omit<IButtonProps, 'children'>) {
  const {
    size = 'md',
    isHidden,
    setIsHidden,
    disabled,
    readonly,
  } = useInputPasswordProps()

  const iconSizeMapping: Record<TInputPasswordSizes, IButtonProps['size']> = {
    md: 'md',
    ml: 'ml',
    lg: 'ml',
    xl: 'ml',
  }

  function handlePress(event: GestureResponderEvent) {
    setIsHidden(!isHidden)
    onPress?.(event)
  }

  if (disabled || readonly) return null

  return (
    <Comp.Button isActive={false}>
      <Button.Root
        {...props}
        variant="neutral-tertiary"
        size={iconSizeMapping[size]}
        onPress={handlePress}
        testID={testID}
      >
        <Button.Icon symbol={isHidden ? 'rdicon-eye' : 'rdicon-eye-off'} />
      </Button.Root>
    </Comp.Button>
  )
}
